/**
 * Extract YouTube video ID and return an embed URL
 * @param {string} url - YouTube URL in various formats
 * @param {number} previewDuration - Duration in seconds for the preview
 * @returns {string} YouTube embed URL
 */
export const getYouTubeEmbedUrl = (url, previewDuration = 10) => {
	// Extract the video ID from various YouTube URL formats
	let videoId = "";

	// Handle youtu.be format
	if (url.includes("youtu.be")) {
		videoId = url.split("youtu.be/")[1]?.split("?")[0];
	}
	// Handle regular youtube.com format
	else if (url.includes("youtube.com/watch")) {
		const urlParams = new URLSearchParams(url.split("?")[1]);
		videoId = urlParams.get("v");
	}
	// Handle youtube.com/embed format (already in embed format)
	else if (url.includes("youtube.com/embed/")) {
		return url; // Already an embed URL
	}

	// Clean up videoId (remove any additional parameters)
	if (videoId.includes("&")) {
		videoId = videoId.split("&")[0];
	}

	// Return the embed URL with parameters
	return `https://www.youtube.com/embed/${videoId}?autoplay=1&mute=1&start=0&end=${previewDuration}&loop=1`;
};
